var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getApplyStatusDetail.msgs)?_c('div',[_c('app-msg',{attrs:{"msgs":_vm.getApplyStatusDetail.msgs,"apply-id":_vm.getApplyStatusDetail.appId,"sender-type":"2"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }